import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getCityNemsisCode, ILocationNemsisLookupData, ILocationInfo } from './getCityNemsisCode.saga'
import { getLocationSearchState } from '../selectors'
import { ILocationSearchState } from '../store/locationSearch.types'
import { LocationSearchConstants } from '../store/locationSearch.constants'
import { getEmployerSelector } from '../../patientDemographics/employer/selectors'
import { IEmployerState } from '../../patientDemographics/employer/store/employer.types'
import { setCity } from '../../patientDemographics/employer/store/employer.actions'
import { EmployerConstants } from '../../patientDemographics/employer/store/employer.constants'
import { setErrorInfo } from '../store/locationSearch.actions'
import Logger from '../../../services/logger.service'
import { ICity } from '../../../common/common.types'
import { areObjectsEqual } from '../../../utilities/object.util'

export function* setEmployerCityNemsisCode() {
  const { errorMsgsMap }: ILocationSearchState = yield select(getLocationSearchState)
  const { city, state, county }: IEmployerState = yield select(getEmployerSelector)
  const locationInfo: ILocationInfo = { city, state, county }
  try {
    const nemsisData: ILocationNemsisLookupData = yield call(getCityNemsisCode, locationInfo)
    if (city) {
      const updatedCity: ICity = { ...city, nemsisCode: nemsisData.city?.nemsisCode || '' }
      errorMsgsMap[EmployerConstants.SET_CITY] = nemsisData.cityError
      errorMsgsMap[EmployerConstants.SET_STATE] = nemsisData.stateError
      errorMsgsMap[EmployerConstants.SET_COUNTY] = nemsisData.countyError
      if (areObjectsEqual(city, updatedCity)) {
        return
      }
      yield put(setCity(updatedCity))
      yield put(setErrorInfo(errorMsgsMap))
    }
  } catch (e) {
    Logger.error(`Error setEmployerCityNemsisCode', ${e}`)
  }
}

export function* setEmployerCityNemsisCodeSaga() {
  yield takeLatest(
    [
      EmployerConstants.SET_EMPLOYER,
      LocationSearchConstants.GET_PATIENT_EMPLOYER_CITY_NEMSIS_CODE,
      EmployerConstants.SET_COUNTY,
      EmployerConstants.SET_STATE,
    ],
    setEmployerCityNemsisCode
  )
}
